/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: App.js file
  Date: April 2020
**/

import React, { useEffect, useState } from 'react';
import { BrowserRouter, Switch, Redirect } from 'react-router-dom';
import LayoutRoute from './routes/layoutRoute';
import { routes } from './routes/routes';
import { useStoreActions, useStoreState } from 'easy-peasy';
import MomentUtils from '@date-io/moment';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ErrorBoundary from './components/globalErrorBoundary';
import {
  globalDateEntity,
  currentUserEntity,
} from './constants/applicationConstants';
import theme from './theme';
import LocalStorageService from './services/localStorage';
import './App.scss';

const localStorageService = LocalStorageService.getService();

const App = () => {
  const loginAction = useStoreActions((actions) => actions.login);
  const customizeAction = useStoreActions((actions) => actions.customize);
  const configData = useStoreState((state) => state.customize.configData);
  const [primaryColor, setPrimaryColor] = useState(
    localStorageService.getColor(),
  );
  const [primaryFontColor, setPrimaryFontColor] = useState(
    localStorageService.getFontColor(),
  );
  // const [primaryFontFamily, setPrimaryFontFamily] = useState(
  //   localStorageService.getFontFamily(),
  // );
  const userRole = useStoreState((state) => state.login.userInfo);
  useEffect(() => {
    // Get config data
    if (localStorageService.getAccessToken()) {
      loginAction.getUserInfo();
    }
  }, []);

  useEffect(() => {
    if (configData && configData.preferences?.primaryColor && configData.preferences?.primaryFontColor) {
      localStorageService.setColor(configData.preferences?.primaryColor);
      localStorageService.setFontColor(configData.preferences?.primaryFontColor);
      localStorageService.setFontFamily(configData.preferences?.primaryFontFamily);

      setPrimaryColor(configData.preferences?.primaryColor);
      setPrimaryFontColor(configData.preferences?.primaryFontColor);
      // setPrimaryFontFamily(configData.preferences?.primaryFontFamily);
    }
  }, [configData]);

  useEffect(() => {
    if (userRole.roles && userRole?.roles?.title?.toLowerCase() !== currentUserEntity.platformAdminTitle) {
        customizeAction.getConfigData();
    }
  }, [userRole]);

  return (
    <ThemeProvider
      theme={theme(
        primaryColor ? primaryColor : globalDateEntity.primaryColor,
        primaryFontColor ? primaryFontColor : globalDateEntity.primaryFontColor,
        globalDateEntity.primaryFontFamily,
        globalDateEntity.secondaryFontFamily,
        configData && configData.backgroundColor
          ? configData.backgroundColor
          : globalDateEntity.backgroundColor,
      )}
    >
      <CssBaseline>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <ErrorBoundary configData={configData}>
            <BrowserRouter>
              <Switch>
                {routes &&
                  routes.map((route, index) => {
                    return (
                      <LayoutRoute
                        exact={
                          route.label === 'PA Trace Results' ? false : true
                        }
                        key={index}
                        requireAuth={route.requireAuth} // Does it require authentication to view page
                        path={route.path} // URL path
                        layout={route.layoutType} // If a different layout then mainlayout
                        page={route.page} // Component to be rendered
                      />
                    );
                  })}

                <Redirect to={{ pathname: '/not-found' }} />
              </Switch>
            </BrowserRouter>
          </ErrorBoundary>
        </MuiPickersUtilsProvider>
      </CssBaseline>
    </ThemeProvider>
  );
};

export default App;
